module.exports = __webpack_public_path__ + "media/images/img_yahoo-527d9d496d804240d24f332ed8c2aa2e.png";